module.exports = __webpack_public_path__ + "img/TEST_IMAGE.cfb7cfe7.jpg";